import type { ThemeClasses } from "../types";
import type { TFunction } from "i18next";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import useIsMonitor from "../../../../../../hooks/useIsMonitor";
import { useTranslation } from "react-i18next";
import { CRUDTooltip } from "../../../../../../components/base/CRUDTooltip";

interface TrailerHeaderProps {
  themeClasses: ThemeClasses;
  onCreateTrailer: () => void;
  t: TFunction;
}

export function TrailerHeader({
  themeClasses,
  onCreateTrailer,
}: TrailerHeaderProps) {
  const { t } = useTranslation("adminSections");
  const disableCRUD = useDisableCRUD();
  const { isMonitor, isReadOnly } = useIsMonitor();
  return (
    <div
      className={`${themeClasses.bg} ${themeClasses.border} p-4 sm:p-6 pb-0`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-4">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            {t("trailers.title")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t("trailers.subtitle")}
          </p>
        </div>
        {!isMonitor && !isReadOnly && (
          <CRUDTooltip className="self-start sm:self-auto flex-shrink-0">
            <button
              onClick={onCreateTrailer}
              disabled={disableCRUD}
              className="px-3 sm:px-4 py-2 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i className="ri-add-line"></i>
              <span className="hidden sm:inline">
                {t("trailers.addTrailer")}
              </span>
              <span className="sm:hidden">Nuevo</span>
            </button>
          </CRUDTooltip>
        )}
      </div>
    </div>
  );
}
